import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import './AnimatedCard.css'

export default class AppMain extends Component {
  render() {
    const {
      name,
      description,
      img,
      alt,
      demoLink,
      viewLink,
      detailSlug,
    } = this.props
    return (
        <figure className="effect-zoe">
          <img src={img || `https://placehold.it/480x258`} alt={alt} />
          <figcaption>
            <h2>{name}</h2>
            <p className="icon-links">
              { detailSlug &&
                <Link className="waves-effect waves-light" to={`/work/${detailSlug}`}>
                  <i className="material-icons right">info</i> details
                </Link>
              }
              { demoLink &&
                <a className="waves-effect waves-light" target="_blank" rel="noopener noreferrer" href={demoLink}>
                  <i className="material-icons right">launch</i> demo
                </a>
              }
              { viewLink &&
                <a className="waves-effect waves-light" target="_blank" rel="noopener noreferrer" href={viewLink}>
                  <i className="material-icons right">launch</i> view
                </a>
              }
            </p>
            <p className="description">{description}</p>
          </figcaption>
        </figure>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/AnimatedCard.js